<template>
    <div class="specialDetaidBox">
        <MaskLoading v-if="isShow"></MaskLoading>
        <!-- <banner :bannerList="bannerList"></banner> -->
        <img src="../../assets/special/db9.jpg" alt="" class="mobileImg" v-if="isMobile">
        <img src="../../assets/special/db9_pc.jpg" alt="" class="mobileImg" v-else>
        <!--  -->
        <div class="special_warpper">
            <div class="p20">
                <backSpecial></backSpecial>
                <div>
                    <div class="arrow_box mb20">
                        <div class="arrow_title">理赔流程</div>
                        <div>
                            <img src="../../assets/special/d9t.jpg" alt="" style="width:100%;display: block;"
                                v-if="isMobile">
                            <img src="../../assets/special/d9t_pc.jpg" alt="" style="width:100%;display: block;" v-else>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">保障內容</div>
                    <div class="table_box mb20">
                        <div class="tab_title_box">
                            <div class="tab_title">
                                <div class="flex flex_warp juc itc" style="height:100%">
                                    <div style="line-height:normal;width: 100%;">互助金领取类型</div>
                                    <div style="font-size:12px;color:#999;line-height:normal;font-weight: normal;">
                                        (会费标准)
                                    </div>
                                </div>
                            </div>
                            <div class="tab_title">
                                <div class="flex flex_warp juc itc" style="height:100%">
                                    <div style="line-height:normal;width: 100%;">慰问金</div>
                                    <div style="font-size:12px;color:#999;line-height:normal;font-weight: normal;">
                                        (31-60日)
                                    </div>
                                </div>
                            </div>
                            <div class="tab_title">
                                <div class="flex flex_warp juc itc" style="height:100%">
                                    <div style="line-height:normal;width: 100%;">互助金(每次)</div>
                                    <div style="font-size:12px;color:#999;line-height:normal;font-weight: normal;">
                                        (60日后)
                                    </div>
                                </div>
                            </div>
                            <div class="tab_title">
                                <div class="flex flex_warp juc itc" style="height:100%">
                                    <div style="line-height:normal;width: 100%;">互助金(最高)</div>
                                    <div style="font-size:12px;color:#999;line-height:normal;font-weight: normal;">
                                        (60日后)
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table_info_box">
                            <div class="row_list">
                                <div class="tab_cell">20元(一份)</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">500元</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">4000元</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">16000元</div>
                            </div>
                            <div class="row_list">
                                <div class="tab_cell">40元(两份)</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">1000元</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">8000元</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">32000元</div>
                            </div>
                            <div class="row_list">
                                <div class="tab_cell">60元(三份)</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">1500元</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">12000元</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">48000元</div>
                            </div>
                            <div class="row_list">
                                <div class="tab_cell">80元(四份)</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">2000元</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">16000元</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">64000元</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">申领材料</div>
                    <div class="desc mb20">
                        1、会员的身份证复印件、受领人的银行卡号及开户行名称。<br>
                        2、由二级以上医疗机构出具的住院病案首页、入院和出院记录(需加盖医院病案室专用章),以及需要由会员提供的其他证明材料。
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">温馨提示</div>
                    <div class="desc mb20">
                        1、本活动保障期为一年。<br>
                        2、首次(或非续保期內)参加本活动的会员在约定生效的互助保障期开始之日起,执行60日观察期。
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">申领材料</div>
                    <div class="desc mb20">
                        1、会员的身份证复印件、受领人的银行卡号及开户行名称。<br>
                        2级以上医疗机构出具的住院病案首页、入院和出院记录(需加盖医院病案室专用章),以及需要由会员提供的其他证明材料。
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">温馨提示</div>
                    <div class="desc mb20">
                        1、本活动保障期为一年。<br>
                        2、首次(或非续保期内)参加本活动的会员在约定生效的互助保障期开始之日起,执行60日观察期。<br>
                        3、会员自疾病确诊之日起,两年内未提交互助金申领手续的,视同为放弃申请互助金的权利。<br>
                        4、在本活动生效60日(不含)后,会员首次确诊患有20类轻度疾病的一类或多类时,每次可领取轻度疾病互助金4000元,同一保障期內会员可多次领取轻度疾病互助金,会员累计领取轻度疾病互助金总金额最高为16,000元,本期所有保障活动待遇终止。<br>
                        5、<span class="tab_link" @click="showDrawer">查看20类轻度疾病。</span>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">咨询电话</div>
                    <footerTel tel="010-67685602"></footerTel>
                </div>

                <div class="footer ">本页面仅供参考,具体以北京市职工互助保障服务中心公示细则为准</div>
            </div>
        </div>
        <!-- 弹层 -->
        <el-drawer title="20类轻度疾病" size="80%" custom-class="custom-class" :visible.sync="drawer" :direction="direction">
            <div class="drawer_box">
                <div class="img_box">
                    <img src="../../assets/special/d9.jpg" alt="" class="drawer_img">
                </div>
            </div>
        </el-drawer>
        <!--  -->
    </div>
</template>

<script>
// import banner from "../../components/banner.vue"
import MaskLoading from "@/components/maskLoading.vue";
import Mixins from "../../script/getMobile";
import backSpecial from "@/components/backSpecial.vue"
import footerTel from "@/components/specialFooterTel.vue"
export default {
    name: "",
    mixins: [Mixins],
    data() {
        return {
            isShow: true,
            drawer: false,
            direction: 'btt',
            bannerList: [
                { "src": require("@/assets/special/baoxiao.jpg") },
                // { "src": require("@/assets/special/baoxiao.jpg") }
            ],
        }
    },
    components: {
        // banner,
        MaskLoading,
        backSpecial,
        footerTel
    },
    mounted() {
        setTimeout(() => {
            this.isShow = false;
        }, 200)
    },
    methods: {
        showDrawer() {
            this.drawer = true;
        }
    },
    activated() {
        window.scrollTo(0, 0);
    },
    deactivated() {
        this.drawer = false;
    }
}
</script>

<style lang="less" scoped>
@import url(../../styles/specialDetail.less);

.specialDetaidBox {
    .arrow_title {
        background-color: #F1F2FD;
    }

    .table_box {

        border: 1px solid #eaeff3;
        overflow: hidden;

        .tab_title_box {
            display: flex;
            flex-wrap: wrap;

            .tab_title {
                flex: 1;
                text-align: center;
                background-color: #F1F2FD;
                line-height: 40px;
                font-size: 13px;
                font-weight: bold;
                border-left: 1px solid #ededed;
                border-bottom: 1px solid #ededed;
                margin-left: -1px;
                padding: 10px 0;
            }
        }


        .table_info_box {
            // display: flex;
            // flex-wrap: wrap;

            .tab_cell {
                flex: 1;
                font-size: 14px;
                text-align: center;
            }

            .row_list {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                width: 100%;
                height: 60px;
                border-bottom: 1px solid #ededed;
                margin-bottom: -1px;
            }

            .sLine {
                width: 1px;
                background-color: #ededed;
                height: 60px;
            }

            .bb1 {
                border-bottom: 1px solid #ededed;
                box-sizing: border-box;
            }

        }



    }
}
</style>